import React, {Component} from "react";

class NewsListItems extends Component {
	render() {
		const {children} = this.props;

		return (
			<div className="news__list__items">
				{children}
			</div>
		);
	}
}

export default NewsListItems;


// WEBPACK FOOTER //
// ./src/app/pages/News/NewsListItems.js